import React,{useState} from 'react'
import {useNavigate} from 'react-router-dom'

function PatientList({patients}) {
    const [patientList,setPatientList] = useState(patients)
    const navigate = useNavigate()
    
    const handleView = (id) =>{
        navigate(`/patient-files/${id}`)
    }

  return (
   <>
    <table className="table table-hover gy-3">
        <thead>
            <tr className='fw-bolder fs-6 text-gray-800 border-bottom border-gray-200'>
               
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Doctor</th>
                <th>Birthdate</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            {patientList && patientList.map(patient=>{
                return <tr key={patient.id}>
                    <td>
                        <div className="d-flex flex-column">
                            <span className="text-hover-primary">  {patient.firstName}</span>
                            {patient.preferredName && <span className="text-muted"> ({patient.preferredName})</span>}
                        </div>
                      
                        
                    </td>
                    <td> {patient.lastName}</td>
                    <td>{patient.email}</td>
                    <td>{patient.doctorName}</td>
                    <td>{patient.dateOfBirth}</td>
                    <td>{patient.patientId ?
                        <button className="btn btn-sm btn-light-primary" onClick={()=>handleView(patient.patientId)}> View</button>
                        :
                        <button className="btn btn-sm btn-light-primary" onClick={()=>handleView(patient.id)}> View</button>
                    }
                    </td>
                   
                </tr>
            })}
        </tbody>
    </table>
   </>
  )
}

export default PatientList